(ns frontend.ui.page.lp-report-editor.step-1-initialization.card.holding-configs
  (:require
    [clojure.data :as data]
    [clojure.set :as set]
    [clojure.string :as string]
    [common.localization :as loc]
    [common.localization :as loc]
    [common.util :as cu]
    [ui.components.button.view :as button]
    [frontend.ui.component.card.view :as card]
    [frontend.ui.component.icon.view :as icon-view]
    [frontend.ui.component.select-input.view :as select-input]
    [frontend.ui.component.table.view :as table]
    [frontend.ui.component.text-input.view :as text-input]
    [frontend.ui.page.lp-report-editor.common.style :as common-style]
    [frontend.ui.page.lp-report-editor.common.view :as common-view]
    [frontend.ui.page.lp-report-editor.step-1-initialization.event :as event]
    [frontend.ui.page.lp-report-editor.step-1-initialization.style :as style]
    [frontend.ui.page.lp-report-editor.step-1-initialization.sub :as sub]
    [frontend.ui.page.lp-report-editor.sub :as editor-sub]
    [frontend.utils :as fu]
    [herb.core :refer [<class] :as h]
    [re-frame.core :as rf]
    [ui.components.toggle.view :as toggle]))

(defn tools
  []
  (let [can-edit? @(rf/subscribe [::sub/can-edit? :step-3])
        edit-mode? @(rf/subscribe [::sub/edit-mode? :step-3])
        collapsed? @(rf/subscribe [::sub/collapsed? :step-3])]
    (concat []
            (when (and (not edit-mode?)
                       can-edit?)
              [[icon-view/icon
                {:class    (<class (fn [] {:margin-right "6px"}))
                 :on-click (fn [e]
                             (fu/prevent-default-event! e)
                             (rf/dispatch [::event/open-edit-mode :step-3])
                             (rf/dispatch [::event/init-holdings]))}
                :edit]])
            (when-not edit-mode?
              [[icon-view/icon
                {:on-click (fn [e]
                             (fu/prevent-default-event! e)
                             (rf/dispatch [::event/toggle-collapse :step-3]))}
                (if collapsed?
                  :angle-down
                  :angle-up)]]))))

(defn footer
  []
  (let [holdings @(rf/subscribe [::editor-sub/lp-report-holdings])
        edited-holdings @(rf/subscribe [::sub/holding-edits])
        [retracts additions no-changes] (data/diff holdings edited-holdings)]
    [:div
     {:class (h/join (h/<class common-style/footer-container)
                     (h/<class common-style/section-border-top))}
     [:div
      {:class (h/<class common-style/footer-left)}
      [button/primary-solid
       {:on-click #(rf/dispatch [::event/add-holding])}
       [:span [:i.fal.fa-plus-circle] (loc/tr :add)]]]
     #_[:div
        {:class (<class common-style/spacing-top)}
        [:div
         {:class (<class common-style/text-uppercase)}
         "Removed"]
        [:div (str retracts)]]

     #_[:div {:class (<class common-style/spacing-top)}
        [:div
         {:class (<class common-style/text-uppercase)}
         "Additions"]
        [:div
         (str additions)]]
     [:div
      {:class (<class common-style/footer-right)}
      [:div
       {:class (<class common-style/spacing-right)}
       [button/secondary-hollow
        {:on-click (fn [e]
                     (rf/dispatch [::event/close-edit-mode :step-3])
                     (rf/dispatch [::event/reset-holdings]))}
        (loc/tr :cancel)]]
      [button/primary-solid
       {:disabled? (or (and (empty? additions)
                            (empty? retracts))
                       (some (fn [holding]
                               (not (cu/blank-value? (:lp-report-holding/name holding))))
                             holdings))
        :on-click  (fn [_]
                     (rf/dispatch [::event/save-holdings retracts additions]))}
       (if @(rf/subscribe [::sub/holdings-processing?])
         [:i.fal.fa-spinner.fa-pulse]
         (loc/tr :save))]]]))

(defn edit-row
  [{:keys [holding tr-props td-props holding-templates-list holding-contributors holding-approvers]
    :as   args}]
  (let [holding-id (:db/id holding)
        template (:lp-report-holding/template-type holding)
        no-reporting? (= template :lp-report-holding-template/no-reporting)
        holding-templates holding-templates-list]
    [:tr
     (assoc tr-props
            :key
            (str "lp-editor-holding-" (:db/id holding)))
     [:td (table/td-props {:style {:white-space "nowrap"}})
      (if (string? holding-id)
        [text-input/text-input
         {:value     (:lp-report-holding/name holding)
          :on-change #(rf/dispatch [::event/holding-change holding-id :lp-report-holding/name %])}]
        (get holding :lp-report-holding/name (loc/tr :not-set)))]
     [:td td-props
      [select-input/select-input
       {:value     template
        :on-change #(rf/dispatch
                     [::event/holding-change holding-id :lp-report-holding/template-type %])}
       holding-templates]]
     [:td td-props
      (if no-reporting?
        (loc/tr :n/a)
        [select-input/select-input
         {:multi?    true
          :value     (:lp-report-holding/text-contributors holding)
          :on-change #(rf/dispatch
                       [::event/holding-change holding-id :lp-report-holding/text-contributors %])}
         holding-contributors])]
     [:td td-props
      (if no-reporting?
        (loc/tr :n/a)
        [select-input/select-input
         {:value     (:lp-report-holding/text-approver holding)
          :on-change #(rf/dispatch
                       [::event/holding-change holding-id :lp-report-holding/text-approver %])}
         holding-approvers])]
     [:td td-props
      (if no-reporting?
        (loc/tr :n/a)
        [select-input/select-input
         {:multi?    true
          :value     (:lp-report-holding/data-contributors holding)
          :on-change #(rf/dispatch
                       [::event/holding-change holding-id :lp-report-holding/data-contributors %])}
         holding-contributors])]
     [:td td-props
      (if no-reporting?
        (loc/tr :n/a)
        [select-input/select-input
         {:value     (:lp-report-holding/data-approver holding)
          :on-change #(rf/dispatch
                       [::event/holding-change holding-id :lp-report-holding/data-approver %])}
         holding-approvers])]]))

(defn display-row
  [{:keys [holding tr-props td-props holding-templates-list holding-contributors holding-approvers]
    :as   args}]
  (let [holding-templates (into {} holding-templates-list)
        template-type (:lp-report-holding/template-type holding)
        no-reporting? (= :lp-report-holding-template/no-reporting template-type)]
    (let [holding-id (:db/id holding)]
      [:tr tr-props
       [:td td-props
        (get holding :lp-report-holding/name (loc/tr :not-set))]
       [:td td-props
        (get holding-templates template-type (loc/tr :not-set))]
       [:td td-props
        (if no-reporting?
          (loc/tr :n/a)
          (if-let [contributors (->> holding
                                     :lp-report-holding/text-contributors
                                     (keep (fn [pid]
                                             (get holding-contributors pid)))
                                     (seq))]
            (string/join ", " contributors)
            (loc/tr :not-set)))]
       [:td td-props
        (if no-reporting?
          (loc/tr :n/a)
          (get holding-approvers
               (:lp-report-holding/text-approver holding)
               (loc/tr :not-set)))]
       [:td td-props
        (if no-reporting?
          (loc/tr :n/a)
          (if-let [contributors (->> holding
                                     :lp-report-holding/data-contributors
                                     (keep (fn [pid]
                                             (get holding-contributors pid)))
                                     (seq))]
            (string/join ", " contributors)
            (loc/tr :not-set)))]
       [:td td-props
        (if no-reporting?
          (loc/tr :n/a)
          (get holding-approvers
               (:lp-report-holding/data-approver holding)
               (loc/tr :not-set)))]])))


(defn chart-editor-selector
  [holding-id chart-editor-roles role]
  [:div
   {:class (h/<class style/chart-editor-input)}
   [toggle/toggle
    {:id         (str holding-id "-text-contributor-chart-editor" role)
     :checked?   (boolean (some chart-editor-roles
                                [role]))
     :on-change (fn [checked?]
                   (let [chart-editors (if checked?
                                         (set/union chart-editor-roles #{role})
                                         (set/difference chart-editor-roles #{role}))]
                     (rf/dispatch [::event/holding-change holding-id :lp-report-holding/chart-editor-roles chart-editors])))}]])

(defn chart-dataset-selector
  [holding-id chart-selector-roles role]
  [:div
   {:class (h/<class style/chart-editor-input)}
   [toggle/toggle
    {:id         (str holding-id "-text-contributor-chart-dataset-selector" role)
     :checked?   (boolean (some chart-selector-roles
                                [role]))
     :on-change (fn [checked?]
                   (let [chart-editors (if checked?
                                         (set/union chart-selector-roles #{role})
                                         (set/difference chart-selector-roles #{role}))]
                     (rf/dispatch [::event/holding-change holding-id :lp-report-holding/chart-selector-roles chart-editors])))}]])

(def editable-holding-templates ;;all the templates that have editable charts
  [:lp-report-holding-template.capman/private-equity-company
   :lp-report-holding-template.capman/private-equity-exit-company
   :lp-report-holding-template.capman/infra-company
   :lp-report-holding-template.capman/private-equity-investment-company
   :lp-report-holding-template.capman/natural-capital-investment
   :lp-report-holding-template.capman/private-equity-special-situations
   :lp-report-holding-template.capman/real-estate-property-nre
   :lp-report-holding-template.capman/real-estate-property-nre-esg
   :lp-report-holding-template.capman/real-estate-portfolio-nre-esg
   :lp-report-holding-template.capman/real-estate-portfolio-koke
   :lp-report-holding-template.capman/real-estate-portfolio-koke-esg
   :lp-report-holding-template.capman/real-estate-property-koke-esg
   :lp-report-holding-template.capman/real-estate-new-investment])

(defn holding-card
  ;; TODO - can we split to smaller components??
  [holding]
  (let [holding-templates @(rf/subscribe [::editor-sub/holding-templates])
        holding-templates (into {} holding-templates)
        edit-mode? @(rf/subscribe [::sub/edit-mode? :step-3])
        template-type (:lp-report-holding/template-type holding)
        holding-id (:db/id holding)
        template (:lp-report-holding/template-type holding)
        no-reporting? (= template :lp-report-holding-template/no-reporting)
        holding-contributors @(rf/subscribe [::editor-sub/holding-contributors])
        holding-approvers @(rf/subscribe [::editor-sub/holding-approvers])
        chart-editor-roles (set (:lp-report-holding/chart-editor-roles holding))
        chart-selector-roles (set (:lp-report-holding/chart-selector-roles holding))
        template-has-editable-graphs? (some #{template-type} editable-holding-templates)]
    ^{:key (str "holding-" (:db/id holding))}
    [:li
     {:class (h/<class style/list-item)}
     (when edit-mode?
       [:label
        {:class (h/<class style/list-item-label)}
        (loc/tr :lp-report-holding/name)])
     [:h2
      {:class (h/<class style/list-item-heading)}
      (if (string? holding-id)
        [text-input/text-input
         {:value     (:lp-report-holding/name holding)
          :on-change #(rf/dispatch [::event/holding-change holding-id :lp-report-holding/name %])}]
        (get holding :lp-report-holding/name (loc/tr :not-set)))]
     [:label
      {:class (h/<class style/list-item-label)}
      (loc/tr :lp-report-holding/template-type)]
     [:div
      {:class (h/<class style/list-item-input)}
      (if edit-mode?
        [select-input/select-input
         {:value     template
          :on-change #(rf/dispatch
                       [::event/holding-change holding-id :lp-report-holding/template-type %])}
         holding-templates]
        (get holding-templates template-type (loc/tr :not-set)))]

     (when-not no-reporting?
       [:<>
        [:div
         {:class (h/<class style/template-label-container)}
         [:label
          {:class (h/<class style/list-item-label)}
          (loc/tr :lp-report-holding/text-contributors)
          (when (and (not edit-mode?)
                     (some #{:lp-report-holding/text-contributors} chart-editor-roles))
            [:span
             {:class (h/<class style/editor-indicator)}
             [:i.fas.fa-chart-pie]])]
         (when (and edit-mode? template-has-editable-graphs?)
           [:label
            {:class (h/<class style/chart-editor-label)}
            (loc/tr :can-edit-charts?)])
         (when (and edit-mode? template-has-editable-graphs?)
           [:label
            {:class (h/<class style/chart-editor-label)}
            (loc/tr :can-change-chart-dataset?)])]
        [:div
         {:class (h/<class style/list-item-value)}
         (if edit-mode?
           [:<>
            [:div
             {:class (h/<class style/list-item-input)}
             [select-input/select-input
              {:multi?    true
               :value     (:lp-report-holding/text-contributors holding)
               :on-change #(rf/dispatch
                            [::event/holding-change holding-id :lp-report-holding/text-contributors %])}
              holding-contributors]]
            (when (and edit-mode? template-has-editable-graphs?)
            [chart-editor-selector holding-id chart-editor-roles :lp-report-holding/text-contributors])
            (when (and edit-mode? template-has-editable-graphs?)
            [chart-dataset-selector holding-id chart-selector-roles :lp-report-holding/text-contributors])]
           (if-let [contributors (->> holding
                                      :lp-report-holding/text-contributors
                                      (keep (fn [pid]
                                              (get holding-contributors pid)))
                                      (seq))]
             (string/join ", " contributors)
             (loc/tr :not-set)))]

        [:label
         {:class (h/<class style/list-item-label)}
         (loc/tr :lp-report-holding/text-approver)
         (when (and (not edit-mode?)
                    (some #{:lp-report-holding/text-approver} chart-editor-roles))
           [:span
            {:class (h/<class style/editor-indicator)}
            [:i.fas.fa-chart-pie]])]
        [:div
         {:class (h/<class style/list-item-value)}
         (if edit-mode?
           [:<>
            [:div
             {:class (h/<class style/list-item-input)}
             [select-input/select-input
              {:value     (:lp-report-holding/text-approver holding)
               :on-change #(rf/dispatch
                            [::event/holding-change holding-id :lp-report-holding/text-approver %])}
              holding-approvers]]
            (when (and edit-mode? template-has-editable-graphs?)
            [chart-editor-selector holding-id chart-editor-roles :lp-report-holding/text-approver])
            (when (and edit-mode? template-has-editable-graphs?)
            [chart-dataset-selector holding-id chart-selector-roles :lp-report-holding/text-approver])]
           (get holding-approvers
                (:lp-report-holding/text-approver holding)
                (loc/tr :not-set)))]
        [:label
         {:class (h/<class style/list-item-label)}
         (loc/tr :lp-report-holding/data-contributors)
         (when (and (not edit-mode?)
                    (some #{:lp-report-holding/data-contributors} chart-editor-roles))
           [:span
            {:class (h/<class style/editor-indicator)}
            [:i.fas.fa-chart-pie]])]
        [:div
         {:class (h/<class style/list-item-value)}
         (if edit-mode?
           [:<>
            [:div
             {:class (h/<class style/list-item-input)}
             [select-input/select-input
              {:multi?    true
               :value     (:lp-report-holding/data-contributors holding)
               :on-change #(rf/dispatch
                            [::event/holding-change holding-id :lp-report-holding/data-contributors %])}
              holding-contributors]]
            (when (and edit-mode? template-has-editable-graphs?)
            [chart-editor-selector holding-id chart-editor-roles :lp-report-holding/data-contributors])
            (when (and edit-mode? template-has-editable-graphs?)
            [chart-dataset-selector holding-id chart-selector-roles :lp-report-holding/data-contributors])]
           (if-let [contributors (->> holding
                                      :lp-report-holding/data-contributors
                                      (keep (fn [pid]
                                              (get holding-contributors pid)))
                                      (seq))]
             (string/join ", " contributors)
             (loc/tr :not-set)))]
        [:label
         {:class (h/<class style/list-item-label)}
         (loc/tr :lp-report-holding/data-approver)
         (when (and (not edit-mode?)
                    (some #{:lp-report-holding/data-approver} chart-editor-roles))
           [:span
            {:class (h/<class style/editor-indicator)}
            [:i.fas.fa-chart-pie]])]
        [:div
         {:class (h/<class style/list-item-value)}
         (if edit-mode?
           [:<>
            [:div
             {:class (h/<class style/list-item-input)}
             [select-input/select-input
              {:value     (:lp-report-holding/data-approver holding)
               :on-change #(rf/dispatch
                            [::event/holding-change holding-id :lp-report-holding/data-approver %])}
              holding-approvers]]
            (when (and edit-mode? template-has-editable-graphs?)
            [chart-editor-selector holding-id chart-editor-roles :lp-report-holding/data-approver])
            (when (and edit-mode? template-has-editable-graphs?)
            [chart-dataset-selector holding-id chart-selector-roles :lp-report-holding/data-approver])]
           (get holding-approvers
                (:lp-report-holding/data-approver holding)
                (loc/tr :not-set)))]])
    ]))

(defn view
  []
  (let [collapsed? @(rf/subscribe [::sub/collapsed? :step-3])
        edit-mode? @(rf/subscribe [::sub/edit-mode? :step-3])
        step-disabled? @(rf/subscribe [::sub/step-disabled? :step-3])
        step-completed? @(rf/subscribe [::sub/step-complete? :step-3])
        report @(rf/subscribe [::editor-sub/lp-report])
        holdings @(rf/subscribe [::sub/holdings :step-3])
        holding-templates @(rf/subscribe [::editor-sub/holding-templates])
        holding-contributors @(rf/subscribe [::editor-sub/holding-contributors])
        holding-approvers @(rf/subscribe [::editor-sub/holding-approvers])
        td-props (table/td-props {})
        tr-props (table/tr-props {})]
    [card/card-with-tools
     {:collapsed?       (or step-disabled? collapsed?)
      :disabled?        step-disabled?
      :toggle-collapsed #(rf/dispatch [::event/toggle-collapse :step-3])
      :icon             (if step-completed?
                          [common-view/icon-step-done]
                          [common-view/icon-step])
      :title            (loc/tr :lp-report-editor-step-3-title)
      :tool-icons       (when-not step-disabled?
                          (tools))}

     [:div (table/container-props)
      [:ul
       {:class (h/<class style/holdings-list)}
       (->> holdings
            (map holding-card)
            (doall))]

      #_[:table (table/table-props {:style {:border-collapse "separate"}})
         [:thead
          [:tr tr-props
           [:th (table/th-props nil #_{:styles {:min-width "300px"}})
            (loc/tr :holding)]
           [:th
            (table/th-props (if edit-mode?
                              {:styles {:min-width "300px"}}))
            (loc/tr :lp-report-holding/template-type)]
           [:th
            (table/th-props (if edit-mode?
                              {:styles {:min-width "300px"}}))
            (loc/tr :lp-report-holding/text-contributors)]
           [:th
            (table/th-props (if edit-mode?
                              {:styles {:min-width "200px"}}))
            (loc/tr :lp-report-holding/text-approver)]
           [:th
            (table/th-props (if edit-mode?
                              {:styles {:min-width "300px"}}))
            (loc/tr :lp-report-holding/data-contributors)]
           [:th
            (table/th-props (if edit-mode?
                              {:styles {:min-width "200px"}}))
            (loc/tr :lp-report-holding/data-approver)]]]
         [:tbody (table/tbody-props {})
          (->> holdings
               (map (fn [holding]
                      (let [row-args {:holding           holding
                                      :tr-props          tr-props
                                      :td-props          td-props
                                      :holding-templates-list holding-templates
                                      :holding-contributors holding-contributors
                                      :holding-approvers holding-approvers}]
                        (if edit-mode?
                          (edit-row row-args)
                          (display-row row-args)))))
               (doall))]]]
     (when edit-mode?
       [footer])]))
